document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.see-more-button').forEach(button => {
    button.addEventListener('click', function() {
      let subMenu = this.previousElementSibling;
      let hiddenItems = subMenu.querySelectorAll('li:nth-child(n+10)'); // Select all items from the 9th onward

      hiddenItems.forEach(item => {
        item.classList.toggle('hidden-item'); // Toggle visibility
      });

      // Update button text
      this.textContent = this.textContent === 'See older models' ? 'See fewer models' : 'See older models';
    });
  });
});